import React, { useEffect, useState } from "react";
import EntityTableTemplate from "../../MyUI/EntityTableTemplate/EntityTableTemplate";
import { paramsConfig as baseConfig } from "./params_conf";
import { getElements2 } from "../../../services/services";

export default function Parameters() {

  const [paramsConfig, setParamsConfig] = useState(baseConfig);

  const fetchElements = async () => {
    try {
      const res = await getElements2({
        filters: [],
        pagen: 1,
        itemsPerPage: 1000,
        sortBy: '',
        sortDesc: false,
      });
      const combboxElements = res.data.params.map(p => ({
        label: `${p.element_name} ${p.pbscode}`,
        value: p.id
      }));

      // Update formFields dynamically
      const updatedFormFields = baseConfig.formFields.map(f => {
        if (f.key === "element_id") {
          return { ...f, Autocomplete: combboxElements };
        }
        return f;
      });

      setParamsConfig({ ...baseConfig, formFields: updatedFormFields });
    } catch (err) {
      console.error("Error fetching elements:", err);
    }
  };
  
    useEffect(() => {
    fetchElements();
  }, []);
  const handleSaved = () => {
    fetchElements();
  };

  if (!paramsConfig) return null;

  return <EntityTableTemplate config={paramsConfig} onSaved2={handleSaved}/>;
}
